import Card from "components/card";
import Navbar from "components/navbar";
import { t } from "i18next";
import { Link } from "react-router-dom";
import { useOnboarding } from "hooks/useOnboarding";
import { OnboardingOverlay, OnboardingReplayButton } from "components/onboarding";
import { settingsOnboarding } from "components/onboarding/steps";
import {
  MdOutlinePayments,
  MdOutlineMap,
  MdOutlineCategory,
  MdOutlineDirectionsCar,
  MdOutlineAccountBalanceWallet,
  MdOutlineArticle,
  MdOutlineSchool,
} from "react-icons/md";
import { IoSettingsOutline } from "react-icons/io5";
import { HiOutlineChevronRight } from "react-icons/hi";

function Settings() {
  const onboarding = useOnboarding(settingsOnboarding);

  const items = [
    {
      id: "settings-card-general",
      title: t("General"),
      description: t("Configurações gerais da aplicação"),
      path: "/admin/settings/general",
      icon: <IoSettingsOutline className="h-5 w-5" />,
      color: "from-cyan-500/20 to-cyan-600/10",
      iconBg: "bg-cyan-500/15 text-cyan-400",
    },
    {
      id: "settings-card-categories",
      title: t("Categories"),
      description: t("Categorias de veículos e tarifas"),
      path: "/admin/settings/categories",
      icon: <MdOutlineCategory className="h-5 w-5" />,
      color: "from-purple-500/20 to-purple-600/10",
      iconBg: "bg-purple-500/15 text-purple-400",
    },
    {
      id: "settings-card-vehicle-types",
      title: t("Vehicle Types"),
      description: t("Mapa de tipos de veículo por categoria"),
      path: "/admin/settings/vehicle-types",
      icon: <MdOutlineDirectionsCar className="h-5 w-5" />,
      color: "from-amber-500/20 to-amber-600/10",
      iconBg: "bg-amber-500/15 text-amber-400",
    },
    {
      id: "settings-card-coverage",
      title: t("Coverage Area"),
      description: t("Área de operação configurada no backend"),
      path: "/admin/settings/coverage-area",
      icon: <MdOutlineMap className="h-5 w-5" />,
      color: "from-green-500/20 to-green-600/10",
      iconBg: "bg-green-500/15 text-green-400",
    },
    {
      id: "settings-card-payment",
      title: t("Payment Methods"),
      description: t("Métodos disponíveis para motoristas e passageiros"),
      path: "/admin/settings/payment-methods",
      icon: <MdOutlinePayments className="h-5 w-5" />,
      color: "from-blue-500/20 to-blue-600/10",
      iconBg: "bg-blue-500/15 text-blue-400",
    },
    {
      id: "settings-card-mercadopago",
      title: t("Config. Mercado Pago"),
      description: t("Vincule a conta e configure split da plataforma"),
      path: "/admin/settings/mercadopago",
      icon: <MdOutlineAccountBalanceWallet className="h-5 w-5" />,
      color: "from-sky-500/20 to-sky-600/10",
      iconBg: "bg-sky-500/15 text-sky-400",
    },
    {
      id: "settings-card-help-center",
      title: t("Help Center"),
      description: t("Artigos de ajuda e meios de contato para os apps"),
      path: "/admin/settings/help-center",
      icon: <MdOutlineArticle className="h-5 w-5" />,
      color: "from-rose-500/20 to-rose-600/10",
      iconBg: "bg-rose-500/15 text-rose-400",
    },
    {
      id: "settings-card-tutorials",
      title: t("Tutoriais"),
      description: t("Páginas de tutorial para passageiros, motoristas e admins"),
      path: "/admin/settings/tutorials",
      icon: <MdOutlineSchool className="h-5 w-5" />,
      color: "from-indigo-500/20 to-indigo-600/10",
      iconBg: "bg-indigo-500/15 text-indigo-400",
    },
  ];

  return (
    <div>
      <Navbar flag={false} brandText={t("Settings")} />
      <OnboardingOverlay
        isActive={onboarding.isActive}
        step={onboarding.currentStep}
        currentIndex={onboarding.currentIndex}
        totalSteps={onboarding.totalSteps}
        onNext={onboarding.next}
        onPrevious={onboarding.previous}
        onSkip={onboarding.skip}
      />
      <Card className="mt-4 p-6">
        <header className="mb-8 flex items-center justify-between">
          <div>
            <div className="text-2xl font-bold text-white">{t("Settings")}</div>
            <p className="mt-1 text-sm text-gray-400">
              {t("Centralize as configurações principais do painel")}
            </p>
          </div>
          <OnboardingReplayButton onReplay={onboarding.replay} />
        </header>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
          {items.map((item) => (
            <Link
              key={item.path}
              id={item.id}
              to={item.path}
              className={`group relative flex items-center justify-between rounded-2xl border border-white/10 bg-gradient-to-br ${item.color} p-5 transition-all duration-200 hover:border-white/20 hover:shadow-lg hover:shadow-black/20 hover:scale-[1.02]`}
            >
              <div className="flex items-center gap-4">
                <div className={`flex h-11 w-11 items-center justify-center rounded-xl ${item.iconBg}`}>
                  {item.icon}
                </div>
                <div>
                  <div className="text-sm font-semibold text-white">
                    {item.title}
                  </div>
                  <div className="text-xs text-gray-400 mt-0.5">
                    {item.description}
                  </div>
                </div>
              </div>
              <HiOutlineChevronRight className="h-4 w-4 text-gray-500 transition-transform duration-200 group-hover:translate-x-1 group-hover:text-white" />
            </Link>
          ))}
        </div>
      </Card>
    </div>
  );
}

export default Settings;
